export enum FieldVariant {
  PREFILLED = 'prefilled',
  ERROR = 'error',
  VALID = 'valid',
  DISABLED = 'disabled'
}

export type FieldCaptionProps = { variant?: FieldVariant };
